import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { cyclopsComponent } from './layouts/cyclops/cyclops.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import {SolutionComponent} from './pages/solution/solution.component'
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { WhoweserveComponent } from './pages/whoweserve/whoweserve.component';
import { WhycyclopsComponent } from './pages/whycyclops/whycyclops.component';
const routes: Routes = [
  { path: '', redirectTo: 'Cyclops', pathMatch: 'full' },
  { path: 'Cyclops', component: cyclopsComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'solution', component: SolutionComponent },
  {path: 'contact' , component: ContactUsComponent},
  {path: 'whoweserve' , component: WhoweserveComponent},
  {path: 'whycyclops' , component: WhycyclopsComponent},




  { path: '**', redirectTo: '' }  // Redirect to home if no route matches
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
  })],
  exports: [RouterModule]
  
})
export class AppRoutingModule { }
